import { render, staticRenderFns } from "./TemplateFields.vue?vue&type=template&id=ee130c3e&scoped=true"
import script from "./TemplateFields.vue?vue&type=script&lang=js"
export * from "./TemplateFields.vue?vue&type=script&lang=js"
import style0 from "./TemplateFields.vue?vue&type=style&index=0&id=ee130c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee130c3e",
  null
  
)

export default component.exports